module.exports = __webpack_public_path__ + "static/media/dog-2.c0ea2ab4.jpg";